import { roomAnyId, RoomAnyId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class RoomMixerStreamGetRequestDTO extends BaseRequestDTO<RoomMixerStreamGetRequestDTORaw> {
  constructor(value: RoomMixerStreamGetRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(
        JsonSchemaValidator.compile({
          type: "object",
          required: ["roomId"],
          properties: {
            roomId: roomAnyId
          },
          additionalProperties: false
        }),
        value
      )
    );
  }

  override toJSON() {
    return this.value;
  }
}

export interface RoomMixerStreamGetRequestDTORaw {
  roomId: RoomAnyId;
}
